function Footer() {
  return (
    <div className='footer'>
      <p className='text-center'> &copy; Dream Maker Studios JSC, 2022. All rights reserved</p>
    </div>
  );
}

export default Footer;
